import React, {Component} from 'react';
import {connect} from 'react-redux';
import {agreementConfirmination} from '../../../actions/agreement.actions';
import {Button, ButtonGroup, PageDescription, StepBox} from '../../Common/PageComponents';
import {joinSteps} from '../../../constants/join.constans';
import {Link} from 'react-router-dom';

class Agreement extends Component {
  _submitAgreement(e) {
    e.preventDefault();
    if (
      !this.agreementOfContract.checked ||
      !this.agreementOfPersonalInforamtionUsage.checked ||
      !this.agreementOfTransferOverseasPersonalInformation.checked
    ) {
      alert('약관에 동의해주세요.');
      return;
    }
    this.props.dispatch(agreementConfirmination('join'));
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (
      nextProps.agreement.join &&
      this.agreementOfContract.checked &&
      this.agreementOfPersonalInforamtionUsage.checked &&
      this.agreementOfTransferOverseasPersonalInformation.checked
    ) {
      this.props.history.push(`/member-service/join/identification`);
    }
  }

  render() {
    return (
      <div className="join-agreement">
        <StepBox steps={joinSteps} activeIndex={0} />
        <PageDescription>
          라이엇 게임즈 프리미엄 PC방 홈페이지 회원 가입을 위해서는 아래 서비스 약관, 개인정보 수집/활용 동의서 및
          개인정보 국외 이전에 관한 동의서를 반드시 읽고 동의 여부를 확인해주셔야 합니다.
        </PageDescription>
        <form>
          <div className="join-agreement__checkbox">
            <label>
              <input type="checkbox" id="yn0" value="y" name="yn0" ref={node => (this.agreementOfContract = node)} />
              &nbsp;서비스 약관에 동의합니다. (필수)
              <a href="http://legal.kr.riotgames.com/pcbang/tos" target="_blank" rel="noopener noreferrer">
                내용확인 &#8599;
              </a>
            </label>
          </div>
          <div className="join-agreement__checkbox">
            <label>
              <input
                type="checkbox"
                id="yn1"
                value="y"
                name="yn1"
                ref={node => (this.agreementOfPersonalInforamtionUsage = node)}
              />
              &nbsp;개인정보 수집, 활용 동의서에 동의합니다. (필수)
              <a
                href="http://legal.kr.riotgames.com/pcbang/privacy-agreement"
                target="_blank"
                rel="noopener noreferrer"
              >
                내용확인 &#8599;
              </a>
            </label>
          </div>
          <div className="join-agreement__checkbox">
            <label>
              <input
                type="checkbox"
                id="yn2"
                value="y"
                name="yn2"
                ref={node => (this.agreementOfTransferOverseasPersonalInformation = node)}
              />
              &nbsp;개인정보 국외 이전에 관한 동의서에 동의합니다. (필수)
              <a
                href="http://legal.kr.riotgames.com/pcbang/overseas-transfer-agreement"
                target="_blank"
                rel="noopener noreferrer"
              >
                내용확인 &#8599;
              </a>
            </label>
          </div>
          <div className="join-agreement__confirm">
            라이엇 게임즈 프리미엄 PC방 서비스 약관, 개인정보 수집/활용 동의서, 개인정보 국외 이전에 관한 동의서에
            동의하십니까?
          </div>
          <ButtonGroup>
            <Button onClick={e => this._submitAgreement(e)}>동의</Button>
            <Link to="/">
              <Button theme="gray">취소</Button>
            </Link>
          </ButtonGroup>
        </form>
      </div>
    );
  }
}

const stateToProps = state => {
  return {
    agreement: state.agreement,
  };
};

export default connect(stateToProps)(Agreement);
